import { TaxSectionProps } from ".";
import { FullSellerRatesHistory, PixConfig } from "../../models/Rates";
import { ArrowIcon } from "../../styles/icons/ArrowIcon";
import { PixIcon } from "../../styles/icons/PixIcon";
import { formatCurrency } from "../../utils";
import { formatPaymentRangeFromApi } from "../../utils/formatPaymentRangeToApi";
import { formatPercentageToNumber } from "../../utils/formatPercentageToNumber";
import { Text } from "../Sellers/styles";
import { Divider, Header, Section } from "./styles";

interface PixSection extends TaxSectionProps {
  pixConfigData: PixConfig;
  defaultPixConfigData: PixConfig;
  actualValue: FullSellerRatesHistory | undefined;
}

export function PixModalVisualization({
  pixConfigData,
  defaultPixConfigData,
  colorFinder,
  actualValue,
}: PixSection) {
  const delayForRedeem = formatTextView("pixConfigData", "delayForRedeem", formatPaymentRangeFromApi);
  const rate = formatTextView("pixConfigData", "rate", formatPercentageToNumber);
  const rateLimitValue = formatTextView("pixConfigData", "rateLimitValue", formatCurrency, true);
  function formatTextView(paymentMethod: string, innerValue: string, formater: (param: any) => any, formaterAsCurrency?: boolean): JSX.Element {
    const pastValue = actualValue?.pastSellerRates?.pixConfigData[innerValue];
    const laterValue = actualValue?.laterSellerRates?.pixConfigData[innerValue];
    if (pastValue === laterValue) {
      return (
        <Text fontSize=".9rem" color="var(--gray-200)">
          {formaterAsCurrency ? formater({value: laterValue}) : formater(laterValue)}
        </Text>
      );
    } else {
      return (
        <Section gap=".4rem" align="center">
          <Text fontSize=".9rem" color={colorFinder(pastValue, defaultPixConfigData[innerValue])}>
            {formaterAsCurrency ? formater({value: pastValue}) : formater(pastValue)}
          </Text>
          <ArrowIcon size={13}/>
          <Text fontSize=".9rem" color={colorFinder(laterValue, defaultPixConfigData[innerValue])}>
            {formaterAsCurrency ? formater({value: laterValue}) : formater(laterValue)}
          </Text>
        </Section>
      );
    }
  }
  return (
    <>
      {pixConfigData && (
        <Section flexDir="column">
          <Section gap=".4rem" margin="1rem 0 0">
            <PixIcon />
            <Header>PIX</Header>
          </Section>
          <Section>
            <Section flexDir="column" gap=".1rem">
              <Text fontSize=".8rem" color="var(--gray-400)">
                Tempo de repasse
              </Text>
              {delayForRedeem}
            </Section>
            <Section flexDir="column" gap=".1rem">
              <Text fontSize=".8rem" color="var(--gray-400)">
                Taxa
              </Text>
              {rate}
            </Section>
            <Section flexDir="column" gap=".1rem">
              <Text fontSize=".8rem" color="var(--gray-400)">
                Limite de taxas
              </Text>
              {rateLimitValue}
            </Section>
          </Section>
          <Divider />
        </Section>
      )}
    </>
  )
}